import React from "react";
import "../styles/global.css";
import Hero from "../components/hero";
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";
import Reveal from "../components/reveal";
import { SliceZone } from "@prismicio/react";
import { components } from "../slices";

const Video = ({ videoData }) => {
  return (
    <div className="max-w-6xl rounded-full w-full block mx-auto px-6 lg:px-8 mt-12 md:mt-32 mb-12 md:mb-44">
      <div
        className="iframe "
        dangerouslySetInnerHTML={{
          __html: videoData.video.html,
        }}
      />
      <div className="mx-auto max-w-xl mt-8">
        <Reveal once={false} threshold={0.4} y={-25} dur={.4}>
          <p className="md:text-xl font-medium md:p-8 mb-4 p-4 mt-8 md:mt-12 bg-blue-50 text-blue-dark">
            {videoData.testimonial.text}
          </p>

          <div className="flex items-center">
            <GatsbyImage
              image={videoData.childImageSharp.gatsbyImageData}
              alt={videoData.testimonial_avatar.alt}
              className="md:w-12 w-10 md:h-12 h-10 rounded-full mr-2" />
            <div>
              <div className="text-blue-dark text-sm font-medium">
                {videoData.name.text}
              </div>
              <div className="text-blue-dark text-opacity-70 text-xs font-medium">
                {videoData.testimonial_position.text}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default function Index ({ data, location }) {
  const videoData = data.prismicHomepageBodyEmbddedVideo
    ? data.prismicHomepageBodyEmbddedVideo.primary
    : null;

    const doc = data.prismicHomepage.data
  return (
    <>
        <div>
          <Hero />
          <SliceZone slices={doc.body} components={components} />
        </div>
      </>
  );
};
export function Head() {
  return (
    <>
      <html lang="en" /> <title>Bankjoy — Digital Banking for Banks and Credit Unions</title>
      <meta
        name="description"
        content="Bankjoy delivers award-winning banking technology, including mobile banking, online banking, e-statements, online account opening, online loan origination, and conversational AI to banks and credit unions — big and small."
      />
      <link rel="preload" href="/fonts/fonts.css" as="style"></link>
      <link rel="canonical" href="https://bankjoy.com/" />
    </>
  );
}

export const query = graphql`
  {
    
    prismicHomepage {
      data {
        body {

          ... on PrismicHomepageDataBodyWhysections {
          slice_type
          primary {
            paragraph_why {
              text
            }
            title_why {
              text
            }
          }
          items {
            icon {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              alt
            }
            subtitle {
              text
            }
            title {
              text
            }
          }
        }
          ... on PrismicHomepageDataBodyReason {
            primary {
            reason_image {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              alt
            }
          }
          slice_type
          items {
            icon {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              alt
            }
            reason_description {
              richText
            }
            reason_title {
              text
            }
          }
        }
          ... on PrismicHomepageDataBodyHerologos {
          slice_type
          items {
            link {
              url
            }
            logo_press {
              gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
              alt
            }
          }
        }
          ... on PrismicHomepageDataBodyFooterLinks {
          slice_type
          items {
            internal
            link {
              url
            }
            title_link {
              text
            }
            slug {
              text
            }
          }
          primary {
            title_links {
              text
            }
          }
        }
          ... on PrismicHomepageDataBodyService {
          id
          items {
            title {
              text
            }
            new_or_not
            link_to_solution {
              link_type
              uid
              url
            }
            image {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              alt
            }
            description {
              text
            }
          }
          slice_type
        }
        ... on PrismicHomepageDataBodyClientLogo {
          slice_type
          items {
            logo {
              alt
              gatsbyImageData(placeholder: NONE,width: 190, layout: CONSTRAINED)
            }
          }
        }
      }
        ogimage {
          url
        }
      }
    }
  }
`;
